import styled from 'styled-components';
import { fontBody } from 'Styles/fonts';
import { black } from 'Styles/colors';

export const FreeShippingProgress = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 370px;
  justify-content: center;
`;

export const Message = styled.p`
  ${fontBody(14)};
  color: ${black};
  margin: 0;
  margin-bottom: 8px;
  text-align: center;
`;

export default {};
